import ServesDescWidget from './component'

export default ServesDescWidget
